import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

import { useLocalStorage } from "@vueuse/core";

import { usePermissions } from "@/use/usePermissions";

import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";

import UiCollapse from "@/components/ui/UiCollapse.vue";

import AccountBalance from "./AccountBalance.vue";
import ManagePayment from "./ManagePayment.vue";
import SetLimitModal from "./SetLimitModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountScore',
  setup(__props) {

const { isAllow } = usePermissions();

const expanded = useLocalStorage("expand-account-info", true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiGroup, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
    default: _withCtx(() => [
      _createVNode(UiCollapse, {
        modelValue: _unref(expanded),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(expanded) ? (expanded).value = $event : null))
      }, {
        header: _withCtx(() => [
          _createVNode(UiHeader, { title: "Лицевой счет" }, {
            right: _withCtx(() => [
              _createVNode(UiIcon, {
                size: 18,
                class: _normalizeClass([{ 'transform-gpu rotate-180': _unref(expanded) }, "transition duration-200"]),
                icon: "ChevronDown"
              }, null, 8, ["class"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          (_unref(isAllow)('score_sub'))
            ? (_openBlock(), _createBlock(AccountBalance, { key: 0 }))
            : _createCommentVNode("", true),
          (_unref(isAllow)('pay'))
            ? (_openBlock(), _createBlock(ManagePayment, {
                key: 1,
                style: {"margin-bottom":"16px"}
              }))
            : _createCommentVNode("", true),
          (_unref(isAllow)('score_limit'))
            ? (_openBlock(), _createBlock(SetLimitModal, { key: 2 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 16))
}
}

})